import React from "react";
import {domain, prepareInfobox} from "./utils";
import Sockette from "./ws";
import { ModalCard, ModalPageHeader, PanelHeader, ModalRoot, platform, PanelHeaderButton, ModalPage, Spinner, Group, SimpleCell, InfoRow, FixedLayout, Div, Button, Snackbar, Panel, PanelHeaderContent, SplitLayout, SplitCol, Platform } from "@vkontakte/vkui";
import { Icon28BugOutline } from '@vkontakte/icons/dist/28/bug_outline_28';
import { Icon28ChevronBack } from '@vkontakte/icons/dist/28/chevron_back_28';
import { Icon24Back } from '@vkontakte/icons/dist/24/back_24';
import { Icon24Cancel } from '@vkontakte/icons/dist/24/cancel_24';

import './Game.css';
import bridge from "@vkontakte/vk-bridge";
import LoadSpinner from "./Spinner";
import { Map } from '../../maps';

const osName = platform();


class Game extends React.Component {
  GAME_NAME = '';
  CONGRATULATION = '';
  CONGRATULATION_PLURAL = '';
  MAP = 'terrain';
  HEADER = '';
  CAPTION = '';

  constructor(props) {
    super(props);
    this.state = {isLoaded: null, startTime: null, regions: [], infobox: null, wsState: null, time: null, points: null, showRules: false, activeModal: null, giveUp: null, showMap: true};
    this.ws = null;
  }

  onPopstate = (event) => {
    if (this.state.activeModal !== null) {
      window.history.pushState({window: 'modal'}, 'modal', '');
      event.stopPropagation();
      this.onCloseModal();
    } else {
      this.props.go();
    }
  }

  componentDidMount() {
    window.history.pushState({window: this.props.id}, 'game', '');
    window.addEventListener("popstate", this.onPopstate, true);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onPopstate, true);
  }

  wsSend = (payload) => {
    if (this.ws && this.ws.isReady() === 1) {
      this.ws.json(payload);
    } else {
      setTimeout(() => {
        this.wsSend(payload);
      }, 100);
    }
  };

  setupWs = () => {
    let addr = `${domain("ws")}/ws/${this.GAME_NAME}/`;
    this.ws = new Sockette(addr, {
      timeout: 5e5,
      onopen: e => this.setState(state => ({...state, wsState: true})),
      onmessage: e => this.dispatchMessage(e),
      onreconnect: e => this.setState(state => ({...state, wsState: null})),
      onmaximum: e => this.props.go(),
      onclose: e => this.setState(state => ({...state, wsState: null})),
      onerror: e => this.props.go(),
    });
  };

  startGame = (params) => {
    this.setState(state => ({...state, ...params, isLoaded: true, startTime: Date.now(), showRules: true}));
  };

  mapInit = () => {
    this.setupWs();
    this.loadData();
  };

  loadData = () => {
  };

  mapClick = (lat, lng) => {
  };

  showInfobox = (infobox) => {
  	this.setState({...this.state, activeModal: 'infobox', infobox: infobox});
	};

  showCongratulation = (time) => {
    let formatTime = time.replace(/^00:/, '').replace(/^0/, '');
  	this.setState({...this.state, activeModal: 'congratulation', time: formatTime}, () => {
  	  this.props.onSetRecord(`${this.props.id}-${this.props.slug}`, formatTime);
    });
	};

  onCloseModal = () => {
  	this.setState({...this.state, activeModal: null});
	};

  showImage = (infobox) => {
    let image = infobox.flag || infobox.coat_of_arms || infobox.image;
    return image ? <SimpleCell><img src={image}/></SimpleCell> : null;
  };

  mainItems() {
    return this.state.regions;
  }

  renderProgress() {
    let solved = this.mainItems().filter(item => item.isSolved);
    return `Найдено ${solved.length} из ${this.mainItems().length}`;
  }

  renderShareButton() {
    const message = `Я ${this.CONGRATULATION} "${this.props.title}" за ${this.state.time}. Сможешь быстрее? https://vk.com/app7440451`;
    return <Button
      key="copy"
      size="l"
      mode="secondary"
      onClick={() => {
        bridge.send("VKWebAppShowWallPostBox", {"message": message});
      }}
    >
      Поделиться
    </Button>;
  }

  renderModal = () => {
  	if (this.state.activeModal === null) {
  		return null;
		}
  	let header = (this.state.activeModal === 'infobox') ?
      <ModalPageHeader after={<PanelHeaderButton onClick={this.onCloseModal} aria-label="Отмена"><Icon24Cancel /></PanelHeaderButton>}>
			  {this.state.infobox.name}
  	  </ModalPageHeader> : null;
  	return <ModalRoot activeModal={this.state.activeModal} onClose={this.onCloseModal}>
      <ModalPage id="infobox" header={header} dynamicContentHeight>
        {this.state.activeModal === 'infobox' &&
          <Group className="disable_select">
            {this.showImage(this.state.infobox)}
            {this.state.infobox.capital &&
              <SimpleCell>
                <InfoRow header="Столица">{this.state.infobox.capital.name}</InfoRow>
              </SimpleCell>}
            {this.state.infobox.area &&
              <SimpleCell>
                <InfoRow header="Площадь">{this.state.infobox.area}</InfoRow>
              </SimpleCell>}
            {this.state.infobox.population &&
              <SimpleCell>
                <InfoRow header="Население">{this.state.infobox.population}</InfoRow>
              </SimpleCell>}
            {this.state.infobox.date &&
              <SimpleCell>
                <InfoRow header="Дата">{this.state.infobox.date}</InfoRow>
              </SimpleCell>}
            {this.state.infobox.mission &&
              <SimpleCell>
                <InfoRow header="Миссия">{this.state.infobox.mission}</InfoRow>
              </SimpleCell>}
            {this.state.infobox.country &&
              <SimpleCell>
                <InfoRow header="Страна">{this.state.infobox.country}</InfoRow>
              </SimpleCell>}
            {this.state.infobox.description &&
              <SimpleCell multiline={true}>
                {this.state.infobox.description}
              </SimpleCell>}
          </Group>}
      </ModalPage>
      <ModalCard id="congratulation" header="Поздравляем!" onClose={this.onCloseModal}
                 actions={[this.renderShareButton()]}>
        {`Вы ${this.CONGRATULATION_PLURAL} "${this.props.title}" за ${this.state.time}`}
      </ModalCard>
    </ModalRoot>;
	};

  onPolygonClick = async (polygon) => {
    if (polygon && (polygon.draggable !== undefined) && !polygon.draggable) {
      let region = this.state.regions.find(x => x.id === polygon.id);
      if (region.infobox.loaded) {
        this.showInfobox(region.infobox);
      } else {
        let id = region.id;
        try {
          let response = await fetch(`${domain('http')}/puzzle/area/${id}/infobox/`, {method: 'GET'});
          let data = await response.json();
          let regions = this.state.regions.map((region) =>
            region.id === id ? {...region, infobox: prepareInfobox(data)} : region);
          this.setState(state => ({...state, regions: regions}), () => {
            this.showInfobox(data);
          });
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  renderLeftButton() {
    return <PanelHeaderButton onClick={this.props.go} data-to="home" aria-label="Домой">
      {osName === Platform.IOS ? <Icon28ChevronBack/> : <Icon24Back/>}
    </PanelHeaderButton>;
  }

  renderGiveUpButton() {
    return this.state.giveUp ? <Button size="m"><Spinner size="small" /></Button> : <Button onClick={this.giveUp} size="m">Сдаюсь!</Button>;
  }

  renderQuestion() {
    return null;
  }

  refreshMap = () => {
    this.setState({...this.state, showMap: false}, () => {this.setState({...this.state, showMap: true})});
  }

  renderBottom() {
    let infobox = this.state.infobox;
    let giveUpEnabled = this.mainItems().filter(item => item.draggable).length > 0;
    if (!infobox && !giveUpEnabled) {
      return null;
    }
    return <FixedLayout vertical="bottom" filled>
      <Div className="footer-container">
        {giveUpEnabled &&
          this.renderGiveUpButton()}
        {infobox &&
          <Button size="m" mode="secondary" onClick={() => this.showInfobox(infobox)} id="infobox_button">
            {(infobox.flag || infobox.coat_of_arms) &&
              <img style={{height: 20, margin: "-10px 10px -5px 0px"}} src={infobox.flag || infobox.coat_of_arms} key={infobox.name}/>}
            {infobox.name}
          </Button>}
        {giveUpEnabled && this.GAME_NAME === 'puzzle' &&
          <Button onClick={this.refreshMap} size="m"><Icon28BugOutline /></Button>}
      </Div>
    </FixedLayout>;
  }

  renderSpinner() {
    return this.state.isLoaded && this.state.wsState ? null : <LoadSpinner />;
  }

  closeRules = () => {
    this.setState({...this.state, showRules: false});
  };

  renderRules() {
    let top = this.renderQuestion() === null ? '' : 'shift-top';
    return <Snackbar onClose={this.closeRules} duration={7000} action="X" onActionClick={this.closeRules} className={top}>
      {this.CAPTION}
    </Snackbar>;
  }

  renderHeader() {
    return <PanelHeader before={this.renderLeftButton()} separator={false}>
      <PanelHeaderContent status={this.renderProgress()}>
        {this.props.title}
      </PanelHeaderContent>
    </PanelHeader>;
  }

  render() {
    return <SplitLayout modal={this.renderModal()} popout={this.renderSpinner()} header={<PanelHeader separator={false}/>}>
      <SplitCol>
        <Panel>
          {this.renderHeader()}
          {this.renderQuestion()}
          {this.state.showRules && this.renderRules()}
          <Map initCallback={this.mapInit} mapClick={this.mapClick} mapTypeId={this.MAP}
               zoom={this.props.zoom} center={{lat: this.props.center[1], lng: this.props.center[0]}}
               regions={this.state.regions} points={this.state.points}
               theme={this.props.theme} planet={this.props.planet}
               infobox={this.state.infobox} showMap={this.state.showMap}
               onPolygonClick={this.onPolygonClick} onDragPolygon={this.onDragPolygon}/>
          {this.renderBottom()}
        </Panel>
      </SplitCol>
    </SplitLayout>;
  }
}

export default Game;
